import React from "react";
import { connect } from "react-redux";
import styled from "styled-components";
import { logout, toggleMenuOpen, setTabCategory } from "common/actions";
import ModalTabSort from "components/ModalTabSort";
import ModalSetting from "components/ModalSetting";

class Menu extends React.Component<
  {
    user: any;
    toggleMenuOpen: () => void;
    setTabCategory: (id: string) => void;
    logout: ({ isLocalDataDelete }: { isLocalDataDelete: boolean }) => void;
  },
  { isOpenSortModal: boolean; isOpenSettingModal: boolean; openMenu: boolean }
> {
  constructor(props) {
    super(props);
    this.state = {
      openMenu: false,
      isOpenSortModal: false,
      isOpenSettingModal: false
    };
  }

  componentDidMount() {
    window.addEventListener("keydown", this._keydown);
  }
  componentWillUnmount() {
    window.removeEventListener("keydown", this._keydown);
  }
  _keydown = async e => {
    if (e.keyCode === 27) {
      if (this.state.isOpenSortModal || this.state.isOpenSettingModal) {
        this.setState({
          isOpenSortModal: false,
          isOpenSettingModal: false
        });
      } else {
        this.props.toggleMenuOpen();
      }
    }
  };

  _toggleMenu() {
    this.props.toggleMenuOpen();
  }

  _openSortModal() {
    this.setState({ isOpenSortModal: true });
  }

  _openSettingModal() {
    this.setState({ isOpenSettingModal: true });
  }

  _closeSortModal() {
    this.setState({ isOpenSortModal: false });
  }

  _closeSettingModal() {
    this.setState({ isOpenSettingModal: false });
  }

  _trashBtn() {
    this.props.toggleMenuOpen();
    this.props.setTabCategory(null);
  }

  render() {
    const { email } = this.props.user;
    const { isOpenSortModal, isOpenSettingModal } = this.state;
    return (
      <Wrapper>
        <div className="menuCover" onClick={() => this._toggleMenu()} />
        <div className="menuContent">
          <button className="menubtn" onClick={() => this._toggleMenu()}>
            <i className="fas fa-times" />
            閉じる
          </button>
          <button className="menubtn" onClick={() => this._openSortModal()}>
            <i className="fas fa-sort-amount-up" />
            タブの並び替え
          </button>
          <button className="menubtn" onClick={() => this._openSettingModal()}>
            <i className="fas fa-cog" />
            設定一覧
          </button>
          <a
            href="https://docs.nabettu.com/contact/"
            target="_blank"
            rel="noopener noreferrer"
            className="menubtn"
          >
            <i className="far fa-comment-alt" />
            お問い合わせ
          </a>
          <button className="menubtn" onClick={() => this._trashBtn()}>
            <i className="fas fa-trash-alt" />
            ゴミ箱
          </button>
          <p className="menubtn">{email}でログイン中</p>
          <button
            className="menubtn"
            onClick={() => this.props.logout({ isLocalDataDelete: true })}
          >
            <i className="fas fa-sign-out-alt" />
            ログアウト
          </button>
        </div>
        {isOpenSortModal && (
          <ModalTabSort onClose={() => this._closeSortModal()} />
        )}
        {isOpenSettingModal && (
          <ModalSetting onClose={() => this._closeSettingModal()} />
        )}
      </Wrapper>
    );
  }
}

export default connect(
  ({ user, categories, memos }) => ({ user, categories, memos }),
  {
    logout,
    toggleMenuOpen,
    setTabCategory
  }
)(Menu);

const Wrapper = styled.div`
  position: relative;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  .menuCover {
    width: 100%;
    height: 100%;
    z-index: 1;
    background-color: rgba(0, 0, 0, 0.1);
  }
  .menuContent {
    background-color: #fff;
    position: absolute;
    width: 200px;
    height: 100%;
    top: 0;
    left: 0;
    display: flex;
    z-index: 1;
    flex-direction: column;
    .menubtn {
      padding: 12px;
      text-align: left;
      color: #333;
      text-decoration: none;
      &:not(:last-child) {
        border-bottom: solid #ccc 1px;
      }
      i {
        margin-right: 8px;
      }
    }
  }
`;
